export const LOGIN = "/login";
export const VERIFY_EMAIL = "/verify-email/:token";
export const FORGOT_PASSWORD = "/forgot-password";
export const RESET_PASSWORD = "/reset-password/:token";
export const REGISTER = "/register";
export const REGISTER_WITH_REFERRAL_LINK = "/r/:referrerscode";
export const ONBOARDING = "/onboarding";

export const DASHBOARD = "/dashboard";
export const INVESTMENTS = "/farms/funding";
export const RENTALS = "/farms/rentals";
export const OWNERSHIPS = "/farms/ownership";
export const FARMS = "/farms";
export const ACTIVEFARMS = "/farms/ownership/:id";
//export const INVESTMENT_ABOUT = "/invest";
export const PROFILE = "/profile";
export const SLOTS = "/slots";
export const REFERRALS = "/referrals";

export const WALLET = "/wallet";

export const EDIBLES = "/edibles";

